/*!
 * sm-popup-bienvenue.js · Pop-up de bienvenue −10 % · boutique Spider-Man
 * v1.0.0 · 2026-10-02 · codé sur mesure pour remplacer EcomSend
 *
 * Chargé par sections/sm-popup-bienvenue.liquid, qui fournit :
 *   #smpb-config         les réglages (JSON) : langue, code, délai…
 *   #smpb-form-template  le formulaire d'inscription natif de Shopify (form 'customer')
 *
 * Tout est isolé dans un Shadow DOM : le CSS du thème ne peut pas déformer le pop-up,
 * et le pop-up ne modifie rien dans le thème. Aucune dépendance externe.
 *
 * Contrôle par l'adresse de la page :
 *   ?smpb=show   affiche le pop-up après 1 s, sans les règles d'affichage (inscription réelle)
 *   ?smpb=test   idem, inscription simulée (jamais sur le thème en ligne)
 *   ?smpb=reset  oublie ce que ce navigateur a mémorisé (fermé, inscrit, acheteur)
 */
(function () {
  'use strict';
  if (window.__smpbBooted) return;
  window.__smpbBooted = true;

  var VERSION = '1.0.0';
  var SECTION_ID = 'sm-popup-bienvenue';
  var MIN_AFTER_LOAD = 2500;   // jamais moins de 2,5 s après l'affichage d'une page
  var RETRY_BUSY = 3000;       // panier ouvert, menu ouvert, saisie en cours : on réessaie
  var K = {
    sub: 'smpb_sub',           // inscrit (ou arrivé depuis un e-mail) : plus jamais de pop-up
    snooze: 'smpb_snooze',     // fermé : pas de pop-up avant cette date (ms)
    buyer: 'smpb_buyer',       // a déjà commandé (posé par le pixel « acheteur »)
    t0: 'smpb_t0',             // début de la visite (sessionStorage)
    shown: 'smpb_shown',       // déjà montré pendant cette visite (sessionStorage)
    pending: 'smpb_pending'    // inscription partie par la page de vérification Shopify
  };
  var EMAIL_RE = /^[^\s@"<>(),;:\\[\]]+@[^\s@"<>(),;:\\[\]]+\.[a-z\u00a1-\uffff]{2,}$/i;

  // --------------------------------------------------------------- textes (7 langues)
  var T = {
    fr: {
      dialog: 'Offre de bienvenue\u00a0: \u221210\u00a0%',
      pct: '\u221210\u00a0%', sub: 'sur ta premi\u00e8re commande',
      eyebrow: 'Offre de bienvenue', title: 'Rejoins la toile\u202f!',
      text: 'Laisse ton e-mail\u00a0: ton code s\u2019affiche tout de suite, et tu d\u00e9couvres nos nouveaut\u00e9s en avant-premi\u00e8re.',
      label: 'Ton adresse e-mail', placeholder: 'Ton adresse e-mail',
      cta: 'Je veux mes \u221210\u00a0%', sending: 'Un instant\u2026', decline: 'Non merci',
      legal: 'En t\u2019inscrivant, tu acceptes de recevoir nos e-mails (nouveaut\u00e9s et offres). D\u00e9sinscription en un clic. Offre valable une fois, sur une premi\u00e8re commande.',
      privacy: 'Politique de confidentialit\u00e9',
      errEmail: 'Cette adresse e-mail n\u2019a pas l\u2019air valide.',
      errNetwork: 'Oups, \u00e7a n\u2019a pas march\u00e9. R\u00e9essaie dans un instant.',
      okTitle: 'Bienvenue dans la toile\u202f!', okText: 'Voici ton code de r\u00e9duction\u00a0:',
      copy: 'Copier', copied: 'Copi\u00e9\u202f!',
      okApplied: 'Il est d\u00e9j\u00e0 appliqu\u00e9 \u00e0 ton panier\u00a0: la r\u00e9duction s\u2019affichera au paiement.',
      okManual: 'Saisis-le au moment du paiement.',
      okNote: 'Valable une fois, sur ta premi\u00e8re commande.',
      cont: 'Continuer mes achats', close: 'Fermer'
    },
    en: {
      dialog: 'Welcome offer: 10% off',
      pct: '\u221210%', sub: 'on your first order',
      eyebrow: 'Welcome offer', title: 'Join the web!',
      text: 'Drop your email: your code appears instantly, and you\u2019ll be the first to see our new arrivals.',
      label: 'Your email address', placeholder: 'Your email address',
      cta: 'Get my 10% off', sending: 'One moment\u2026', decline: 'No thanks',
      legal: 'By signing up, you agree to receive our emails (new arrivals and offers). Unsubscribe in one click. Valid once, on a first order.',
      privacy: 'Privacy policy',
      errEmail: 'This email address doesn\u2019t look valid.',
      errNetwork: 'Oops, that didn\u2019t work. Please try again in a moment.',
      okTitle: 'Welcome to the web!', okText: 'Here\u2019s your discount code:',
      copy: 'Copy', copied: 'Copied!',
      okApplied: 'It\u2019s already applied to your cart: you\u2019ll see the discount at checkout.',
      okManual: 'Enter it at checkout.',
      okNote: 'Valid once, on your first order.',
      cont: 'Continue shopping', close: 'Close'
    },
    de: {
      dialog: 'Willkommensangebot: 10\u00a0% Rabatt',
      pct: '\u221210\u00a0%', sub: 'auf deine erste Bestellung',
      eyebrow: 'Willkommensangebot', title: 'Ab ins Netz!',
      text: 'Gib deine E-Mail-Adresse ein: Dein Code erscheint sofort, und du erf\u00e4hrst vor allen anderen von unseren Neuheiten.',
      label: 'Deine E-Mail-Adresse', placeholder: 'Deine E-Mail-Adresse',
      cta: 'Meine 10\u00a0% sichern', sending: 'Einen Moment \u2026', decline: 'Nein, danke',
      legal: 'Mit deiner Anmeldung willigst du ein, unsere E-Mails (Neuheiten und Angebote) zu erhalten. Abmeldung jederzeit mit einem Klick. Einmal g\u00fcltig, nur bei einer Erstbestellung.',
      privacy: 'Datenschutzerkl\u00e4rung',
      errEmail: 'Diese E-Mail-Adresse scheint ung\u00fcltig zu sein.',
      errNetwork: 'Hoppla, das hat nicht geklappt. Bitte versuche es gleich noch einmal.',
      okTitle: 'Willkommen im Netz!', okText: 'Hier ist dein Rabattcode:',
      copy: 'Kopieren', copied: 'Kopiert!',
      okApplied: 'Er ist bereits in deinem Warenkorb hinterlegt: Der Rabatt wird an der Kasse abgezogen.',
      okManual: 'Gib ihn an der Kasse ein.',
      okNote: 'Einmal g\u00fcltig, bei deiner ersten Bestellung.',
      cont: 'Weiter einkaufen', close: 'Schlie\u00dfen'
    },
    nl: {
      dialog: 'Welkomstaanbieding: 10% korting',
      pct: '\u221210%', sub: 'op je eerste bestelling',
      eyebrow: 'Welkomstaanbieding', title: 'Spring in het web!',
      text: 'Laat je e-mailadres achter: je code verschijnt meteen en je bent als eerste op de hoogte van nieuwe producten.',
      label: 'Je e-mailadres', placeholder: 'Je e-mailadres',
      cta: 'Claim mijn 10% korting', sending: 'Even geduld\u2026', decline: 'Nee, bedankt',
      legal: 'Door je in te schrijven ga je akkoord met het ontvangen van onze e-mails (nieuwe producten en aanbiedingen). Uitschrijven kan met \u00e9\u00e9n klik. Eenmalig geldig, op een eerste bestelling.',
      privacy: 'Privacybeleid',
      errEmail: 'Dit e-mailadres lijkt niet geldig.',
      errNetwork: 'Oeps, dat is niet gelukt. Probeer het zo meteen opnieuw.',
      okTitle: 'Welkom in het web!', okText: 'Hier is je kortingscode:',
      copy: 'Kopi\u00ebren', copied: 'Gekopieerd!',
      okApplied: 'Hij staat al in je winkelwagen: je ziet de korting bij het afrekenen.',
      okManual: 'Vul hem in bij het afrekenen.',
      okNote: 'Eenmalig geldig, op je eerste bestelling.',
      cont: 'Verder winkelen', close: 'Sluiten'
    },
    it: {
      dialog: 'Offerta di benvenuto: 10% di sconto',
      pct: '\u221210%', sub: 'sul tuo primo ordine',
      eyebrow: 'Offerta di benvenuto', title: 'Entra nella ragnatela!',
      text: 'Lascia la tua email: il codice appare subito e scopri le novit\u00e0 in anteprima.',
      label: 'Il tuo indirizzo email', placeholder: 'Il tuo indirizzo email',
      cta: 'Voglio il mio \u221210%', sending: 'Un attimo\u2026', decline: 'No, grazie',
      legal: 'Iscrivendoti accetti di ricevere le nostre email (novit\u00e0 e offerte). Puoi annullare l\u2019iscrizione con un clic. Valido una sola volta, su un primo ordine.',
      privacy: 'Informativa sulla privacy',
      errEmail: 'Questo indirizzo email non sembra valido.',
      errNetwork: 'Ops, qualcosa non ha funzionato. Riprova tra un attimo.',
      okTitle: 'Ti diamo il benvenuto nella ragnatela!', okText: 'Ecco il tuo codice sconto:',
      copy: 'Copia', copied: 'Copiato!',
      okApplied: '\u00c8 gi\u00e0 applicato al tuo carrello: vedrai lo sconto al momento del pagamento.',
      okManual: 'Inseriscilo al momento del pagamento.',
      okNote: 'Valido una sola volta, sul tuo primo ordine.',
      cont: 'Continua lo shopping', close: 'Chiudi'
    },
    es: {
      dialog: 'Oferta de bienvenida: 10\u00a0% de descuento',
      pct: '\u221210\u00a0%', sub: 'en tu primer pedido',
      eyebrow: 'Oferta de bienvenida', title: '\u00a1Entra en la telara\u00f1a!',
      text: 'D\u00e9janos tu correo: tu c\u00f3digo aparece al instante y descubrir\u00e1s las novedades antes que nadie.',
      label: 'Tu correo electr\u00f3nico', placeholder: 'Tu correo electr\u00f3nico',
      cta: 'Quiero mi \u221210\u00a0%', sending: 'Un momento\u2026', decline: 'No, gracias',
      legal: 'Al suscribirte, aceptas recibir nuestros correos (novedades y ofertas). Puedes darte de baja con un clic. V\u00e1lido una sola vez, en un primer pedido.',
      privacy: 'Pol\u00edtica de privacidad',
      errEmail: 'Esta direcci\u00f3n de correo no parece v\u00e1lida.',
      errNetwork: 'Vaya, algo ha fallado. Int\u00e9ntalo de nuevo en un momento.',
      okTitle: '\u00a1Te damos la bienvenida a la telara\u00f1a!', okText: 'Aqu\u00ed tienes tu c\u00f3digo de descuento:',
      copy: 'Copiar', copied: '\u00a1Copiado!',
      okApplied: 'Ya est\u00e1 aplicado a tu carrito: ver\u00e1s el descuento al pagar.',
      okManual: 'Introd\u00facelo al pagar.',
      okNote: 'V\u00e1lido una sola vez, en tu primer pedido.',
      cont: 'Seguir comprando', close: 'Cerrar'
    },
    pl: {
      dialog: 'Oferta powitalna: 10% zni\u017cki',
      pct: '\u221210%', sub: 'na pierwsze zam\u00f3wienie',
      eyebrow: 'Oferta powitalna', title: 'Do\u0142\u0105cz do sieci!',
      text: 'Zostaw sw\u00f3j e-mail: kod pojawi si\u0119 od razu, a o nowo\u015bciach dowiesz si\u0119 przed innymi.',
      label: 'Tw\u00f3j adres e-mail', placeholder: 'Tw\u00f3j adres e-mail',
      cta: 'Odbieram 10% zni\u017cki', sending: 'Chwileczk\u0119\u2026', decline: 'Nie, dzi\u0119kuj\u0119',
      legal: 'Zapisuj\u0105c si\u0119, zgadzasz si\u0119 na otrzymywanie naszych e-maili (nowo\u015bci i oferty). Mo\u017cesz si\u0119 wypisa\u0107 jednym klikni\u0119ciem. Oferta wa\u017cna jednorazowo, przy pierwszym zam\u00f3wieniu.',
      privacy: 'Polityka prywatno\u015bci',
      errEmail: 'Ten adres e-mail wygl\u0105da na nieprawid\u0142owy.',
      errNetwork: 'Ups, co\u015b posz\u0142o nie tak. Spr\u00f3buj ponownie za chwil\u0119.',
      okTitle: 'Witaj w sieci!', okText: 'Oto Tw\u00f3j kod rabatowy:',
      copy: 'Kopiuj', copied: 'Skopiowano!',
      okApplied: 'Kod jest ju\u017c dodany do Twojego koszyka: zni\u017cka pojawi si\u0119 przy p\u0142atno\u015bci.',
      okManual: 'Wpisz go przy p\u0142atno\u015bci.',
      okNote: 'Kod wa\u017cny jednorazowo, przy Twoim pierwszym zam\u00f3wieniu.',
      cont: 'Kontynuuj zakupy', close: 'Zamknij'
    }
  };

  // --------------------------------------------------------------- styles (Shadow DOM)
  var CSS = [
    ':host{all:initial}',
    '*,*::before,*::after{box-sizing:border-box}',
    '[hidden]{display:none!important}',
    '.ov{--red:#e62429;--red2:#b80000;--blue:#0057b8;--navy:#10132b;--txt:#4a4f63;--mut:#7d8398;--line:#d9dce6;',
    'position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;',
    'padding:24px;background:rgba(9,11,26,.62);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);opacity:0;',
    'transition:opacity .28s ease;font-family:Outfit,"Helvetica Neue",Helvetica,Arial,sans-serif;font-size:16px;line-height:1.4;',
    'color:var(--navy);text-align:left;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;',
    'overscroll-behavior:contain;-webkit-tap-highlight-color:transparent}',
    '.ov.on{opacity:1}',
    '.dlg{position:relative;display:grid;grid-template-columns:42% 58%;width:100%;max-width:780px;',
    'max-height:calc(100vh - 48px);background:#fff;border-radius:18px;overflow:hidden;outline:none;',
    'box-shadow:0 30px 90px rgba(0,0,0,.45);transform:translateY(16px) scale(.97);opacity:.4;',
    'transition:transform .34s cubic-bezier(.2,.8,.2,1),opacity .34s ease}',
    '.ov.on .dlg{transform:none;opacity:1}',
    /* panneau visuel */
    '.vis{position:relative;z-index:0;overflow:hidden;display:flex;flex-direction:column;justify-content:flex-end;',
    'min-height:440px;padding:34px 28px 118px;color:#fff;',
    'background:radial-gradient(130% 95% at 12% 8%,#ff4b4f 0%,#e62429 28%,#b80000 62%,#5c0000 100%)}',
    '.vis.img{background:linear-gradient(180deg,rgba(184,0,0,.30) 0%,rgba(110,0,0,.78) 55%,rgba(60,0,0,.94) 100%),var(--img) center/cover no-repeat}',
    '.web{position:absolute;top:-1px;left:-1px;width:560px;height:560px;color:#fff;opacity:.2;pointer-events:none;z-index:-1}',
    '.band{position:absolute;left:-25%;right:-25%;bottom:-50px;height:132px;transform:rotate(-8deg);',
    'background:var(--blue);box-shadow:0 -6px 0 rgba(0,0,0,.18);z-index:-1}',
    '.band::after{content:"";position:absolute;top:0;right:0;bottom:0;left:0;',
    'background-image:radial-gradient(rgba(255,255,255,.3) 1.3px,transparent 1.7px);background-size:9px 9px}',
    '.off{margin:0}',
    '.pct{display:inline-block;font-family:Archivo,"Arial Black",Impact,sans-serif;font-weight:700;font-size:86px;',
    'line-height:.92;letter-spacing:-.045em;white-space:nowrap;transform:skewX(-9deg);transform-origin:left bottom;',
    'color:#fff!important;text-shadow:4px 4px 0 var(--blue),8px 8px 0 rgba(0,0,0,.28)}',
    '.sub{display:block;max-width:230px;margin-top:16px;font-size:13px;font-weight:700;line-height:1.35;',
    'letter-spacing:.14em;text-transform:uppercase;color:#fff!important}',
    /* panneau formulaire */
    '.bd{position:relative;z-index:0;display:flex;flex-direction:column;justify-content:center;',
    'padding:44px 42px 30px;overflow-x:hidden;overflow-y:auto;-webkit-overflow-scrolling:touch}',
    '.web2{position:absolute;right:0;bottom:0;width:300px;height:300px;transform:rotate(180deg);',
    'color:var(--blue);opacity:.07;pointer-events:none;z-index:-1}',
    '.eb{margin:0 0 10px;font-size:12px;font-weight:700;line-height:1.3;letter-spacing:.18em;text-transform:uppercase;color:var(--blue)!important}',
    '.title{margin:0 0 10px;font-family:Archivo,"Helvetica Neue",Arial,sans-serif;font-size:32px;font-weight:700;',
    'line-height:1.08;letter-spacing:-.01em;color:var(--navy)!important;outline:none}',
    '.text{margin:0 0 22px;font-size:16px;line-height:1.5;color:var(--txt)!important}',
    '.fm{position:relative;margin:0}',
    '.in{display:block;width:100%;height:54px;margin:0;padding:0 16px;border:2px solid var(--line);border-radius:12px;',
    'background:#fff;color:var(--navy);font:500 16px/1.2 Outfit,"Helvetica Neue",Arial,sans-serif;outline:none;',
    'box-shadow:none;-webkit-appearance:none;appearance:none;transition:border-color .15s,box-shadow .15s}',
    '.in::placeholder{color:#9aa0b4;opacity:1}',
    '.in:focus{border-color:var(--blue);box-shadow:0 0 0 4px rgba(0,87,184,.16)}',
    '.in[aria-invalid="true"]{border-color:var(--red2);box-shadow:0 0 0 4px rgba(184,0,0,.12)}',
    '.cta{position:relative;display:flex;align-items:center;justify-content:center;gap:10px;width:100%;min-height:54px;',
    'margin:12px 0 0;padding:12px 20px;border:0;border-radius:12px;background:var(--red);color:#fff!important;',
    'font:700 16px/1.2 Outfit,"Helvetica Neue",Arial,sans-serif;letter-spacing:.06em;text-transform:uppercase;',
    'text-align:center;cursor:pointer;box-shadow:0 5px 0 var(--red2);-webkit-appearance:none;appearance:none;',
    'transition:transform .1s,box-shadow .1s,background-color .15s}',
    '.cta:hover{background:#f0262c}',
    '.cta:active{transform:translateY(3px);box-shadow:0 2px 0 var(--red2)}',
    '.cta:focus-visible,.copy:focus-visible,.no:focus-visible,.x:focus-visible,.legal a:focus-visible{outline:3px solid var(--blue);outline-offset:3px}',
    '.cta[disabled]{cursor:progress;opacity:.82;transform:none}',
    '.cta svg{flex:none;width:18px;height:18px}',
    '.err{margin:10px 0 0;font-size:14px;font-weight:600;line-height:1.4;color:var(--red2)!important}',
    '.err:empty{margin:0}',
    '.no{display:block;margin:12px auto 0;padding:6px 10px;border:0;background:none;color:var(--mut)!important;',
    'font:500 14px/1.3 Outfit,"Helvetica Neue",Arial,sans-serif;text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
    '.no:hover{color:var(--navy)!important}',
    '.legal{margin:14px 0 0;font-size:11.5px;line-height:1.5;color:var(--mut)!important}',
    '.legal a{color:var(--blue)!important;text-decoration:underline;text-underline-offset:2px}',
    '.x{position:absolute;top:14px;right:14px;z-index:3;display:flex;align-items:center;justify-content:center;',
    'width:40px;height:40px;margin:0;padding:0;border:0;border-radius:50%;background:rgba(16,19,43,.06);',
    'color:var(--navy);cursor:pointer;transition:background-color .15s,transform .2s}',
    '.x:hover{background:rgba(16,19,43,.12);transform:rotate(90deg)}',
    '.x svg{width:18px;height:18px}',
    '.sr{position:absolute!important;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}',
    '.hp{position:absolute!important;left:-9999px;top:0;width:1px;height:1px;overflow:hidden}',
    /* étape « code » */
    '.okic{display:flex;align-items:center;justify-content:center;width:56px;height:56px;margin:0 0 16px;border-radius:50%;',
    'background:var(--red);color:#fff;box-shadow:0 0 0 7px rgba(230,36,41,.14)}',
    '.okic svg{width:28px;height:28px}',
    '.code{display:flex;align-items:center;gap:12px;margin:4px 0 14px;padding:10px 10px 10px 20px;',
    'border:2px dashed var(--blue);border-radius:14px;background:#f2f6ff;animation:smpbPop .45s cubic-bezier(.2,.9,.3,1.35)}',
    '.codev{flex:1;min-width:0;font-family:Archivo,"Helvetica Neue",Arial,sans-serif;font-size:26px;font-weight:700;',
    'letter-spacing:.12em;line-height:1.2;color:var(--navy)!important;overflow-wrap:anywhere;-webkit-user-select:all;user-select:all}',
    '.copy{flex:none;min-height:44px;margin:0;padding:0 18px;border:0;border-radius:10px;background:var(--blue);color:#fff!important;',
    'font:700 14px/1 Outfit,"Helvetica Neue",Arial,sans-serif;letter-spacing:.05em;text-transform:uppercase;cursor:pointer;',
    'transition:background-color .15s}',
    '.copy.ok{background:#1d7d46}',
    '.hint{margin:0 0 6px;font-size:15px;line-height:1.5;color:var(--txt)!important}',
    '.note{margin:0;font-size:13px;line-height:1.5;color:var(--mut)!important}',
    '.cta-cont{margin-top:20px}',
    '@keyframes smpbPop{from{transform:scale(.9);opacity:0}to{transform:none;opacity:1}}',
    /* téléphone : feuille qui monte du bas */
    '@media (max-width:719px){',
    '.ov{align-items:flex-end;padding:0;padding-bottom:var(--kb,0px)}',
    '.dlg{grid-template-columns:1fr;max-width:none;max-height:calc(100% - 12px);border-radius:22px 22px 0 0;transform:translateY(105%);opacity:1}',
    '.vis{min-height:0;flex-direction:row;align-items:center;justify-content:flex-start;padding:22px 64px 22px 22px}',
    '.off{display:flex;align-items:center;gap:16px}',
    '.pct{font-size:56px;text-shadow:3px 3px 0 var(--blue),6px 6px 0 rgba(0,0,0,.25)}',
    '.sub{margin:0;max-width:170px;font-size:11.5px;letter-spacing:.12em}',
    '.band,.web2{display:none}',
    '.web{width:420px;height:420px;opacity:.18}',
    '.x{top:12px;right:12px;background:rgba(255,255,255,.18);color:#fff}',
    '.x:hover{background:rgba(255,255,255,.3)}',
    '.bd{padding:24px 22px calc(18px + env(safe-area-inset-bottom,0px))}',
    '.title{font-size:26px}',
    '.text{margin-bottom:16px;font-size:15px}',
    '}',
    '@media (max-width:359px){.pct{font-size:46px}.title{font-size:23px}.bd{padding-left:18px;padding-right:18px}.vis{padding-left:18px}}',
    '@media (min-width:720px) and (max-height:620px){.vis{min-height:0;padding:24px 24px 100px}.pct{font-size:68px}',
    '.bd{padding:30px 36px 22px}.title{font-size:27px}.text{margin-bottom:14px}.legal{margin-top:10px}}',
    '@media (prefers-reduced-motion:reduce){.ov,.dlg,.cta,.x,.copy{transition:none!important}.code{animation:none!important}.dlg{transform:none!important}}'
  ].join('');

  var ICON = {
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    ok: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    go: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"/></svg>'
  };

  // --------------------------------------------------------------- état
  var cfg, t, params, mode, forced, dry, reduced, coarse;
  var state = 'closed';
  var host = null, root = null, els = {}, lastFocus = null, sending = false, downOnBackdrop = false;
  var prevHtmlOverflow = null;

  try { boot(); } catch (err) { if (window.console) console.warn('[smpb]', err); }

  function boot() {
    cfg = readConfig();
    if (!cfg) return;
    if (!('attachShadow' in Element.prototype) || !window.fetch || !window.URLSearchParams || !window.Promise) return;
    params = new URLSearchParams(window.location.search);
    mode = String(params.get('smpb') || '').toLowerCase();
    forced = mode === 'show' || mode === 'test';
    var onLiveTheme = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main');
    dry = !!cfg.designMode || (mode === 'test' && !onLiveTheme);
    reduced = mq('(prefers-reduced-motion: reduce)');
    coarse = mq('(pointer: coarse)');
    window.smpbPopup = { version: VERSION, open: function () { open({}); } };

    if (mode === 'reset') resetState();

    if (cfg.designMode) { setupEditor(); return; }

    // Arrivée depuis un e-mail marketing : déjà abonné.
    if (/^e-?mail$/i.test(params.get('utm_medium') || '')) store(K.sub, '1');

    // Retour d'une inscription.
    var postedOk = params.get('customer_posted') === 'true';
    var postedExisting = !postedOk && params.get('form_type') === 'customer';
    if (sget(K.pending) === '1') {
      sdel(K.pending);
      if (postedOk || postedExisting) {
        // l'inscription est passée par la page de vérification Shopify : on montre le code
        store(K.sub, '1');
        if (cfg.autoApply) applyCode();
        track('smpb_subscribe', { status: postedOk ? 'ok-verif' : 'existing-verif' });
        setTimeout(function () { open({ success: true }); }, 400);
        return;
      }
    } else if (postedOk) {
      store(K.sub, '1'); // inscrit à l'instant par un autre formulaire (pied de page)
    }

    if (!forced && !eligible()) return;
    schedule();
  }

  function readConfig() {
    var el = document.getElementById('smpb-config');
    if (!el) return null;
    try {
      var c = JSON.parse(el.textContent || '{}');
      return c && typeof c === 'object' ? c : null;
    } catch (e) { return null; }
  }

  function langOf(c) { return String((c && c.locale) || 'fr').toLowerCase().split(/[-_]/)[0]; }
  function mq(q) { try { return window.matchMedia(q).matches; } catch (e) { return false; } }

  // --------------------------------------------------------------- mémoire du navigateur
  function store(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { cookieSet(k, v, 400); } }
  function load(k) {
    var v = null;
    try { v = window.localStorage.getItem(k); } catch (e) { /* stockage bloqué */ }
    return v !== null ? v : cookieGet(k);
  }
  function unstore(k) { try { window.localStorage.removeItem(k); } catch (e) { /* rien */ } cookieSet(k, '', -1); }
  function sget(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* rien */ } }
  function sdel(k) { try { window.sessionStorage.removeItem(k); } catch (e) { /* rien */ } }
  function cookieGet(k) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function cookieSet(k, v, days) {
    try {
      document.cookie = k + '=' + encodeURIComponent(v) + '; path=/; max-age=' + Math.round(days * 86400) +
        '; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '');
    } catch (e) { /* rien */ }
  }
  function resetState() {
    [K.sub, K.snooze, K.buyer].forEach(unstore);
    [K.t0, K.shown, K.pending].forEach(sdel);
  }
  function subscribed() { return load(K.sub) === '1'; }

  // --------------------------------------------------------------- qui voit le pop-up
  function eligible() {
    if (!cfg.enabled || !String(cfg.code || '').trim()) return false;
    if (isBot()) return false;
    if (subscribed()) return false;
    if (load(K.buyer) === '1') return false;
    if (sget(K.shown) === '1') return false;
    var until = parseInt(load(K.snooze) || '0', 10);
    if (until && Date.now() < until) return false;
    // filet de sécurité : le Liquid écarte déjà ces pages
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:account|challenge|password|policies|checkouts?)(?:[\/?#]|$)/i.test(window.location.pathname)) return false;
    return true;
  }

  function isBot() {
    return /googlebot|adsbot|storebot|google-inspectiontool|bingbot|bingpreview|yandex(?:bot|images|mobilebot)|baiduspider|duckduckbot|applebot|petalbot|ahrefsbot|semrushbot|mj12bot|dotbot|slurp|facebookexternalhit|facebot|twitterbot|linkedinbot|pinterestbot|embedly|crawler|spider|lighthouse|pagespeed|headlesschrome|bot\//i
      .test(navigator.userAgent || '');
  }

  function delayMs() {
    var d = Number(cfg.delay);
    if (!isFinite(d)) d = 10;
    return Math.min(Math.max(d, 0), 600) * 1000;
  }

  function reshowMs() {
    var d = Number(cfg.reshowDays);
    if (!isFinite(d) || d < 1) d = 7;
    return Math.min(d, 365) * 864e5;
  }

  // Le délai court depuis l'ARRIVÉE sur la boutique, pas depuis chaque page : un visiteur
  // qui change de page au bout de 6 s voit le pop-up 4 s plus tard (2,5 s au minimum).
  function schedule() {
    var now = Date.now();
    var t0 = parseInt(sget(K.t0) || '', 10);
    if (!(t0 > 0) || t0 > now) {
      t0 = (window.performance && performance.timeOrigin) ? Math.round(performance.timeOrigin) : now;
      sset(K.t0, String(t0));
    }
    var wait = forced ? 1000 : Math.max(delayMs() - (now - t0), MIN_AFTER_LOAD);
    setTimeout(tryOpen, wait);
  }

  function tryOpen() {
    if (state !== 'closed') return;
    if (!forced && !eligible()) return;
    if (document.hidden) {
      var onVis = function () {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', onVis);
        setTimeout(tryOpen, 1500);
      };
      document.addEventListener('visibilitychange', onVis);
      return;
    }
    if (busy()) { setTimeout(tryOpen, RETRY_BUSY); return; }
    open({});
  }

  // Ne jamais couvrir le panier, le menu, une fenêtre du thème ou une saisie en cours.
  function busy() {
    var a = document.activeElement;
    if (a && a !== document.body) {
      if (a.isContentEditable || a.tagName === 'TEXTAREA' || a.tagName === 'SELECT') return true;
      if (a.tagName === 'INPUT' && !/^(button|submit|reset|checkbox|radio|range|color|file|image|hidden)$/i.test(a.type || '')) return true;
    }
    var b = document.body, h = document.documentElement;
    if (/(?:^|\s)(?:modal-open|js-drawer-open|overflow-hidden)(?:\s|$)/.test(b.className || '')) return true;
    try {
      if (getComputedStyle(b).overflowY === 'hidden' || getComputedStyle(h).overflowY === 'hidden') return true;
    } catch (e) { /* rien */ }
    return false;
  }

  // --------------------------------------------------------------- éditeur de thème
  function setupEditor() {
    var ours = function (e) {
      return !!e && ((e.detail && e.detail.sectionId === SECTION_ID) ||
        (e.target && e.target.id === 'shopify-section-' + SECTION_ID));
    };
    document.addEventListener('shopify:section:select', function (e) {
      if (!ours(e)) return;
      cfg = readConfig() || cfg;
      if (state !== 'closed') teardown();
      open({});
    });
    document.addEventListener('shopify:section:deselect', function (e) { if (ours(e)) close('editor'); });
    document.addEventListener('shopify:section:load', function (e) {
      if (!ours(e)) return;
      cfg = readConfig() || cfg;
      if (state !== 'closed') { teardown(); open({}); }
    });
  }

  // --------------------------------------------------------------- construction
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Toile d'araignée accrochée dans un coin : rayons + fils qui se creusent vers le centre.
  function webSVG(cls, size) {
    var R = size, rays = 8, rings = 12, a = [], spokes = '', threads = '', i, j;
    var f = function (x) { return Math.round(x * 10) / 10; };
    for (i = 0; i < rays; i++) a.push(i / (rays - 1) * Math.PI / 2);
    for (i = 0; i < rays; i++) spokes += 'M0 0L' + f(R * 1.05 * Math.cos(a[i])) + ' ' + f(R * 1.05 * Math.sin(a[i]));
    for (j = 1; j <= rings; j++) {
      var r = R * Math.pow(j / rings, 1.12), sag = r * (j % 2 ? 0.935 : 0.95);
      for (i = 0; i < rays - 1; i++) {
        var m = (a[i] + a[i + 1]) / 2;
        threads += 'M' + f(r * Math.cos(a[i])) + ' ' + f(r * Math.sin(a[i])) +
          'Q' + f(sag * Math.cos(m)) + ' ' + f(sag * Math.sin(m)) + ' ' +
          f(r * Math.cos(a[i + 1])) + ' ' + f(r * Math.sin(a[i + 1]));
      }
    }
    return '<svg class="' + cls + '" viewBox="0 0 ' + R + ' ' + R + '" aria-hidden="true" focusable="false">' +
      '<path d="' + spokes + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      '<path d="' + threads + '" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>';
  }

  function markup() {
    var code = String(cfg.code || '').trim();
    var img = cfg.image ? String(cfg.image) : '';
    var visAttr = img ? ' class="vis img" style="--img:url(\'' + esc(img.replace(/['()\\]/g, '')) + '\')"' : ' class="vis"';
    return '' +
      '<div class="ov" part="overlay">' +
        '<div class="dlg" role="dialog" aria-modal="true" aria-labelledby="smpb-t1" aria-describedby="smpb-d1" tabindex="-1">' +
          '<button type="button" class="x" aria-label="' + esc(t.close) + '">' + ICON.x + '</button>' +
          '<div' + visAttr + '>' + webSVG('web', 560) + '<div class="band"></div>' +
            '<p class="off"><span class="pct">' + esc(t.pct) + '</span><span class="sub">' + esc(t.sub) + '</span></p>' +
          '</div>' +
          '<div class="bd">' + webSVG('web2', 300) +
            '<div class="s-form">' +
              '<p class="eb">' + esc(t.eyebrow) + '</p>' +
              '<h2 class="title" id="smpb-t1">' + esc(t.title) + '</h2>' +
              '<p class="text" id="smpb-d1">' + esc(t.text) + '</p>' +
              '<form class="fm" novalidate>' +
                '<label class="sr" for="smpb-email">' + esc(t.label) + '</label>' +
                '<input class="in" id="smpb-email" type="email" name="contact[email]" required autocomplete="email" inputmode="email"' +
                  ' autocapitalize="off" autocorrect="off" spellcheck="false" enterkeyhint="send" aria-describedby="smpb-err"' +
                  ' placeholder="' + esc(t.placeholder) + '">' +
                '<div class="hp" aria-hidden="true"><input type="text" name="smpb_website" tabindex="-1" autocomplete="off"></div>' +
                '<button type="submit" class="cta cta-go"><span class="lbl">' + esc(t.cta) + '</span>' + ICON.go + '</button>' +
                '<p class="err" id="smpb-err" role="alert" aria-live="assertive"></p>' +
              '</form>' +
              '<button type="button" class="no">' + esc(t.decline) + '</button>' +
              '<p class="legal">' + esc(t.legal) + ' <a href="' + esc(cfg.privacyUrl || '/policies/privacy-policy') +
                '" target="_blank" rel="noopener">' + esc(t.privacy) + '</a></p>' +
            '</div>' +
            '<div class="s-ok" hidden>' +
              '<div class="okic">' + ICON.ok + '</div>' +
              '<h2 class="title" id="smpb-t2" tabindex="-1">' + esc(t.okTitle) + '</h2>' +
              '<p class="text" style="margin-bottom:12px">' + esc(t.okText) + '</p>' +
              '<div class="code"><span class="codev">' + esc(code) + '</span>' +
                '<button type="button" class="copy">' + esc(t.copy) + '</button></div>' +
              '<p class="hint">' + esc(cfg.autoApply ? t.okApplied : t.okManual) + '</p>' +
              '<p class="note">' + esc(t.okNote) + '</p>' +
              '<button type="button" class="cta cta-cont">' + esc(t.cont) + '</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function build() {
    destroyNow();
    t = T[langOf(cfg)] || T.en;
    host = document.createElement('div');
    host.id = 'smpb-host';
    // z-index maximal : le pop-up passe au-dessus de la bulle du chatbot (elle aussi au maximum, mais
    // chargée avant). La vérification hCaptcha, ajoutée après, reste au-dessus du pop-up.
    host.setAttribute('style', 'position:relative!important;z-index:2147483647!important;display:block!important;');
    root = host.attachShadow({ mode: 'open' });
    root.innerHTML = '<style>' + CSS + '</style>' + markup();
    document.body.appendChild(host);

    var $ = function (s) { return root.querySelector(s); };
    els = {
      ov: $('.ov'), dlg: $('.dlg'), form: $('.fm'), email: $('.in'), hp: $('.hp input'),
      go: $('.cta-go'), lbl: $('.cta-go .lbl'), err: $('.err'), stepForm: $('.s-form'), stepOk: $('.s-ok'),
      okTitle: $('#smpb-t2'), copy: $('.copy'), x: $('.x'), no: $('.no'), cont: $('.cta-cont')
    };
    if (cfg.email) els.email.value = String(cfg.email);

    els.ov.addEventListener('pointerdown', function (e) { downOnBackdrop = e.target === els.ov; });
    els.ov.addEventListener('click', function (e) {
      if (e.target === els.ov && downOnBackdrop) close('backdrop');
      downOnBackdrop = false;
    });
    els.x.addEventListener('click', function () { close('x'); });
    els.no.addEventListener('click', function () { close('decline'); });
    els.cont.addEventListener('click', function () { close('done'); });
    els.copy.addEventListener('click', copyCode);
    els.form.addEventListener('submit', onSubmit);
    els.email.addEventListener('input', function () {
      if (els.err.textContent) { els.err.textContent = ''; els.email.removeAttribute('aria-invalid'); }
    });
  }

  function destroyNow() {
    if (host && host.parentNode) host.parentNode.removeChild(host);
    host = null; root = null; els = {};
    state = 'closed';
  }

  // Démontage complet et immédiat (écouteurs, défilement, DOM). Sans risque si déjà fait.
  function teardown() {
    document.removeEventListener('keydown', onKey, true);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', onViewport);
      window.visualViewport.removeEventListener('scroll', onViewport);
    }
    unlockScroll();
    destroyNow();
  }

  // --------------------------------------------------------------- ouverture / fermeture
  function open(opts) {
    opts = opts || {};
    if (state !== 'closed' || !document.body) return;
    build();
    state = 'open';
    if (!forced && !dry && !opts.success) sset(K.shown, '1');
    lastFocus = document.activeElement;
    lockScroll();
    document.addEventListener('keydown', onKey, true);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', onViewport);
      window.visualViewport.addEventListener('scroll', onViewport);
    }
    if (opts.success) showSuccess(true);
    if (reduced) els.ov.classList.add('on');
    else requestAnimationFrame(function () { requestAnimationFrame(function () { if (els.ov) els.ov.classList.add('on'); }); });
    setTimeout(function () {
      if (state !== 'open') return;
      var target = opts.success ? els.okTitle : (coarse ? els.dlg : els.email);
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    }, reduced ? 0 : 80);
    track('smpb_view', { success: !!opts.success });
  }

  function close(reason) {
    if (state !== 'open') return;
    state = 'closing';
    if (!dry && reason !== 'editor' && !subscribed()) store(K.snooze, String(Date.now() + reshowMs()));
    document.removeEventListener('keydown', onKey, true);
    unlockScroll();
    if (els.ov) els.ov.classList.remove('on');
    var finish = function () {
      if (state !== 'closing') return;
      teardown();
      var f = lastFocus;
      lastFocus = null;
      if (f && f.focus && document.documentElement.contains(f)) {
        try { f.focus({ preventScroll: true }); } catch (e) { /* rien */ }
      }
    };
    if (reduced) finish(); else setTimeout(finish, 320);
    track('smpb_close', { reason: reason });
  }

  // Bloque le défilement de la page derrière, sauf si ça ferait sauter la mise en page
  // (barre de défilement classique sur ordinateur).
  function lockScroll() {
    var h = document.documentElement;
    if (window.innerWidth - h.clientWidth > 0) return;
    prevHtmlOverflow = h.style.overflow;
    h.style.overflow = 'hidden';
  }
  function unlockScroll() {
    if (prevHtmlOverflow === null) return;
    document.documentElement.style.overflow = prevHtmlOverflow;
    prevHtmlOverflow = null;
  }

  // Clavier du téléphone ouvert : la feuille remonte au-dessus.
  function onViewport() {
    var vv = window.visualViewport;
    if (!vv || !els.ov) return;
    var kb = Math.round(window.innerHeight - vv.height - vv.offsetTop);
    els.ov.style.setProperty('--kb', (kb > 60 ? kb : 0) + 'px');
  }

  function focusables() {
    var list = els.dlg.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([tabindex="-1"])');
    return Array.prototype.filter.call(list, function (n) { return n.offsetParent !== null; });
  }

  function onKey(e) {
    if (state !== 'open') return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close('escape'); return; }
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1], cur = root.activeElement;
    if (e.shiftKey && (cur === first || !cur || cur === els.dlg || cur === els.okTitle)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (cur === last || !cur)) { e.preventDefault(); first.focus(); }
  }

  // --------------------------------------------------------------- inscription
  function onSubmit(e) {
    e.preventDefault();
    if (sending) return;
    var email = String(els.email.value || '').trim();
    if (!EMAIL_RE.test(email)) { fail('email'); return; }
    if (els.hp.value) { succeed('hp'); return; } // robot : on fait semblant, rien n'est envoyé
    setSending(true);
    // Si la vérification anti-robot traîne (défi hCaptcha), le bouton redevient cliquable.
    var slow = setTimeout(function () { setSending(false); }, 12000);
    (dry ? simulate(email) : send(email)).then(function (outcome) {
      clearTimeout(slow);
      handle(outcome, email);
    }, function () {
      clearTimeout(slow);
      handle('network', email);
    });
  }

  function handle(outcome, email) {
    setSending(false);
    if (outcome === 'ok' || outcome === 'existing' || outcome === 'unknown') { succeed(outcome); return; }
    if (state !== 'open') return;
    if (outcome === 'challenge') { nativeSubmit(email); return; }
    fail(outcome === 'invalid' ? 'email' : 'network');
  }

  function setSending(on) {
    sending = !!on;
    if (!els.go) return;
    els.go.disabled = sending;
    els.go.setAttribute('aria-busy', sending ? 'true' : 'false');
    els.lbl.textContent = sending ? t.sending : t.cta;
  }

  function fail(kind) {
    if (state !== 'open') return;
    els.err.textContent = kind === 'email' ? t.errEmail : t.errNetwork;
    if (kind === 'email') {
      els.email.setAttribute('aria-invalid', 'true');
      try { els.email.focus({ preventScroll: true }); } catch (e) { els.email.focus(); }
    }
  }

  function succeed(kind) {
    if (!dry) store(K.sub, '1');
    if (!dry && cfg.autoApply && kind !== 'hp') applyCode();
    track('smpb_subscribe', { status: kind, simulated: dry });
    if (state === 'open') showSuccess(false);
  }

  function showSuccess(instant) {
    els.stepForm.hidden = true;
    els.stepOk.hidden = false;
    els.dlg.setAttribute('aria-labelledby', 'smpb-t2');
    els.dlg.removeAttribute('aria-describedby');
    if (!instant) setTimeout(function () {
      if (state !== 'open') return;
      try { els.okTitle.focus({ preventScroll: true }); } catch (e) { els.okTitle.focus(); }
    }, 30);
  }

  // Formulaire « miroir » hors Shadow DOM : c'est lui que Shopify protège (hCaptcha
  // invisible) et lui qui part, exactement comme le formulaire newsletter du pied de page.
  function templateForm() {
    var tpl = document.getElementById('smpb-form-template');
    return tpl && tpl.content ? tpl.content.querySelector('form') : null;
  }

  var mirrors = 0;
  function makeMirror(email) {
    var src = templateForm();
    var f = document.createElement('form');
    f.id = 'smpb-mirror-' + (++mirrors);
    f.method = 'post';
    f.setAttribute('action', (src && src.getAttribute('action') ? src.getAttribute('action') : '/contact').split('#')[0]);
    f.setAttribute('accept-charset', 'UTF-8');
    f.setAttribute('aria-hidden', 'true');
    f.setAttribute('style', 'position:fixed!important;left:-10000px!important;top:0!important;width:1px!important;' +
      'height:1px!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important;');
    var hidden = src ? src.querySelectorAll('input[type="hidden"]') : [];
    if (hidden.length) {
      Array.prototype.forEach.call(hidden, function (inp) {
        if (!inp.name) return;
        f.appendChild(Object.assign(document.createElement('input'), { type: 'hidden', name: inp.name, value: inp.value }));
      });
    } else {
      [['form_type', 'customer'], ['utf8', '\u2713'], ['contact[tags]', 'newsletter,pop-up email,pop-up email ' + langOf(cfg)]]
        .forEach(function (p) { f.appendChild(Object.assign(document.createElement('input'), { type: 'hidden', name: p[0], value: p[1] })); });
    }
    var em = Object.assign(document.createElement('input'), { type: 'hidden', name: 'contact[email]', value: email });
    em.setAttribute('value', email);
    f.appendChild(em);
    document.body.appendChild(f);
    return f;
  }

  function removeMirror(f) {
    if (f && f.parentNode) f.parentNode.removeChild(f);
  }

  function send(email) {
    return new Promise(function (resolve) {
      var settled = false, posted = false;
      var mirror = makeMirror(email);
      var finish = function (outcome) {
        if (settled) return;
        settled = true;
        removeMirror(mirror);
        resolve(outcome);
      };
      var ajax = function () {
        if (posted) return;
        posted = true;
        post(mirror).then(finish, function () { finish('network'); });
      };
      // Shopify appelle cette fonction une fois le jeton anti-robot ajouté au formulaire.
      mirror.submit = ajax;
      var cap = window.Shopify && window.Shopify.captcha;
      if (cap && typeof cap.protect === 'function') {
        var bound = false;
        try {
          cap.protect(mirror, function () {
            bound = true;
            try { mirror.submit(); } catch (err) { ajax(); }
          });
        } catch (err) { ajax(); return; }
        setTimeout(function () { if (!bound) ajax(); }, 20000);   // hCaptcha injoignable : envoi direct
        setTimeout(function () { finish('timeout'); }, 120000);  // défi abandonné
      } else {
        ajax();
      }
    });
  }

  function post(form) {
    var body = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { body.append(k, v); });
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 25000) : null;
    return fetch(form.getAttribute('action'), {
      method: 'POST', body: body, credentials: 'same-origin', redirect: 'follow',
      headers: { Accept: 'text/html' }, signal: ctrl ? ctrl.signal : undefined
    }).then(function (res) {
      if (timer) clearTimeout(timer);
      var url = res.url || '';
      if (/\/challenge(?:[\/?#]|$)/.test(url)) return 'challenge';
      if (!res.ok) return 'http';
      return res.text().then(function (html) { return classify(url, html); }, function () { return classify(url, ''); });
    });
  }

  // Shopify redirige : ?customer_posted=true (nouvel inscrit), ?…form_type=customer
  // (adresse déjà connue), /challenge (vérification). La section renvoie aussi un témoin
  // data-smpb-state dans la page reçue.
  function classify(url, html) {
    var m = /data-smpb-state="(ok|error)"(?:\s+data-smpb-errors="([^"]*)")?/.exec(html || '');
    if (/[?&]customer_posted=true/.test(url) || (m && m[1] === 'ok')) return 'ok';
    if (m && m[1] === 'error') return /email/i.test(m[2] || '') ? 'invalid' : 'error';
    if (/[?&]form_type=customer/.test(url)) return 'existing';
    return 'unknown';
  }

  // Shopify exige une vérification visible : on envoie le formulaire normalement, la page
  // de vérification s'affiche, puis le retour sur la boutique ouvre le pop-up sur le code.
  function nativeSubmit(email) {
    sset(K.pending, '1');
    var f = makeMirror(email);
    HTMLFormElement.prototype.submit.call(f);
  }

  function simulate(email) {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve(/panne/i.test(email) ? 'http' : /erreur/i.test(email) ? 'invalid' : /existe/i.test(email) ? 'existing' : 'ok');
      }, 700);
    });
  }

  // Pose le code dans le panier (cookie de réduction Shopify) : il s'appliquera au paiement.
  function applyCode() {
    var code = String(cfg.code || '').trim();
    if (!code) return;
    try {
      fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'),
        { credentials: 'same-origin', headers: { Accept: 'application/json' } }).catch(function () { /* rien */ });
    } catch (e) { /* rien */ }
  }

  function copyCode() {
    var code = String(cfg.code || '').trim();
    var btn = els.copy;
    var done = function () {
      if (!btn) return;
      btn.textContent = t.copied;
      btn.classList.add('ok');
      track('smpb_copy', {});
      setTimeout(function () { if (btn) { btn.textContent = t.copy; btn.classList.remove('ok'); } }, 2200);
    };
    var legacy = function () {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.setAttribute('style', 'position:fixed;top:-1000px;left:0;opacity:0;');
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      try { btn.focus({ preventScroll: true }); } catch (e) { /* rien */ }
      if (ok) done();
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, legacy);
    else legacy();
  }

  // Événements internes Shopify (lisibles par un pixel personnalisé). Rien n'est envoyé ailleurs.
  function track(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var payload = { locale: langOf(cfg), version: VERSION };
        for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* rien */ }
  }
})();
